export const LAND_WARNINGS_SLUG = "land-warnings";
export const MARITIME_WARNINGS_SLUG = "maritime-warnings";

export const landWarningsPath = (slug: string) => `/${slug}/${LAND_WARNINGS_SLUG}`;
export const maritimeWarningsPath = (slug: string) => `/${slug}/${MARITIME_WARNINGS_SLUG}`;
